export default "__VITE_ASSET__BTYMaA8z__"